import React, { useEffect, useState } from "react";
import moment from "moment";

import useStyles from "./styles";
import MaterialTable from "@material-table/core";
import { Grid, Paper, Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import * as UsersApi from "../../api/users";
import { isOk } from "../../result";
import { Link, useNavigate } from "react-router-dom";

export interface AdminEventProps {
  userId: string;
}

const AdministratorEventsCollection = ({ userId }: AdminEventProps) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const rowsPerPage = mobile ? 5 : 10;

  const [state, setstate] = useState({
    administratorEvents: [] as any,
    loading: false,
    problem: null as any
  });

  useEffect(() => {
    getAdministratorEvents();
  }, []);

  const getAdministratorEvents = () => {
    setstate({ ...state, loading: true });
    UsersApi.listAdministratorEventsByAdmin(userId).then(result => {
      if (!isOk(result)) {
        return setstate({
          ...state,
          loading: false,
          problem: result.details
        });
      }

      return setstate({
        ...state,
        loading: false,
        administratorEvents: result.value
      });
    });
  };

  return (
    <div style={{ position: "relative" }}>
      <MaterialTable
        title={""}
        isLoading={state.loading}
        columns={[
          {
            title: "Timestamp",
            field: "timeStamp",
            cellStyle: { padding: "8px 20px 8px 8px" },
            render: (row: any) =>
              moment(row.timeStamp).format("YYYY-MM-DD HH:mm")
          },
          {
            title: "TenantId",
            field: "tenantId",
            hidden: true,
            cellStyle: { padding: "8px 20px 8px 8px" }
          },
          {
            title: "TargetId",
            field: "targetId",
            hidden: true,
            cellStyle: { padding: "8px 20px 8px 8px" }
          },
          {
            title: "Event",
            field: "event",
            cellStyle: { padding: "8px" }
          },
          {
            title: "Tenant",
            field: "tenantName",
            cellStyle: { padding: "8px" }
          },
          {
            title: "User",
            field: "targetName",
            cellStyle: { padding: "8px" }
          }
        ]}
        data={
          state.administratorEvents ? (state.administratorEvents as []) : []
        }
        detailPanel={[
          rowData => ({
            disabled: !rowData.data,
            render: () => {
              if (rowData.data) {
                return (
                  <Grid container spacing={2} className={classes.historyPanel}>
                    {Object.keys(rowData.data).map((d: any) => {
                      return (
                        <Grid item xs={12} lg={3}>
                          <Typography variant="body2">
                            <strong>
                              {d.charAt(0).toUpperCase() + d.slice(1)}
                            </strong>
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            gutterBottom
                          >
                            {Array.isArray(rowData.data[d])
                              ? rowData.data[d].join(", ")
                              : rowData.data[d].toString()}
                          </Typography>
                        </Grid>
                      );
                    })}
                  </Grid>
                );
              } else return "";
            }
          })
        ]}
        components={{
          Container: props => <Paper {...props} elevation={0} />
        }}
        options={{
          search: true,
          showTitle: false,
          pageSize: rowsPerPage,
          pageSizeOptions: [10, 20, 50, 100],
          emptyRowsWhenPaging: true,
          searchFieldAlignment: mobile ? "left" : "right",
          headerStyle: {
            padding: "8px"
          }
        }}
      />
    </div>
  );
};
export default AdministratorEventsCollection;
